<template>
    <div class="seat"
    :style="{
        '--seatSelectedColor': styling.seatSelectedColor,
        '--seatSelectedColorOwned': styling.seatSelectedColor + '99',
        '--seatOccupiedColor': styling.seatOccupiedColor,
        '--seatAvailable0Color': styling.seatAvailable0Color,
        '--seatAvailable1Color': styling.seatAvailable1Color,
        '--seatAvailable2Color': styling.seatAvailable2Color,
        '--seatAvailableColor': seatMapGroupColor,
        '--fontFamily': styling.fontFamily,
        '--fontColor1': styling.fontColor1,
        '--fontColor2': styling.fontColor2,
        '--fontColor3': styling.fontColor3,
    }"
    :class="this.styles" v-if="seat.designator !== 'AISLE' && seat.designator !== 'NOSEAT'" @click="handleSelection" :data-seat-selected="seatSelectedDataAttribute">
    <span :class="{'seat-price ${this.showPriceOnSeats}': this.columns <= 9, 'seat-price-sm': this.columns > 9}" v-if="this.canBeSelected && this.showPriceOnSeats">{{ formatCentPrice(seat.price) }}</span>
        <div class="seat--info" v-if="this.hasHoverSeatInfo" v-bind:class="{active: !this.canBeSelected}">
            <strong class="seat--info-passenger" v-if="!this.canBeSelected">{{ getPassengerByDesignator(seat.designator) }}</strong>
            <strong v-if="this.canBeSelected">{{ seat.designator }}</strong>
            <span v-if="this.canBeSelected">{{ formatCurrency(seat.price) }}</span>
            <span v-if="this.canBeSelected && seat.ancillaries && seat.ancillaries.priorityBoarding">{{ text.priority_boarding }}</span>
            <span v-if="this.canBeSelected && seat.ancillaries && seat.ancillaries.fastExit">{{ text.fast_exit }}</span>
        </div>
      <div class="seat--info seat--info-child" v-if="showHoverErrorChild">
        <span>{{ text.error_select_seat_child }}</span>
      </div>
      <div class="seat--info seat--info-infant" v-if="showHoverErrorInfant">
        <span>{{ text.error_select_seat_infant}}</span>
      </div>
        <div class="seat-border"></div>
    </div>
    <div
    :style="{
        '--fontFamily': styling.fontFamily,
        '--fontColor1': styling.fontColor1,
        '--fontColor2': styling.fontColor2,
        '--fontColor3': styling.fontColor3
    }"
    class="seat seat--empty" v-else>{{ seat.designator === 'AISLE' ? seat.row : '' }}</div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import '@fortawesome/fontawesome-free/css/all.css'
export default {
  props: ['seat', 'priceMap', 'text', 'styling', 'columns'],
  methods: {
    handleSelection () {
      if (this.isTakenByCurrentPassenger) {
        this.deselectSeat(this.currentPassenger)
      } else if (this.canBeSelected) {
        this.selectSeat(this.seat)

        if (this.nextPassengerId) {
          this.changePassenger(this.nextPassengerId)
        } else if (this.autoChangeFlight) {
          this.nextFlight(true)
        }
      }
    },

    ...mapActions(['selectSeat', 'changePassenger', 'deselectSeat', 'nextFlight'])
  },

  computed: {
    ...mapGetters(['currentPassenger', 'selectedSeatsOnThisFlight', 'nextPassengerId', 'formatCurrency', 'getPassengerByDesignator', 'formatCentPrice']),
    ...mapState(['autoChangeFlight', 'showPriceOnSeats']),

    showHoverErrorChild () {
      if (this.seat.available && ['child', 'teen'].includes(this.currentPassenger.type)) {
        return !this.seat.childAllowed
      }
      return false
    },

    showHoverErrorInfant () {
      if (this.seat.available && this.currentPassenger.infant) {
        return !this.seat.infantAllowed
      }
      return false
    },

    seatMapGroup () {
      return this.priceMap.filter(item => item.group === this.seat.group)[0]
    },

    seatMapGroupColor () {
      if (this.seatMapGroup) {
        return this.seatMapGroup.color
      }
      return ''
    },

    hasExtraLeg () {
      if (this.seatMapGroup.hasOwnProperty('color')) {
        return this.seat.extraLeg
      }

      return this.seat.group === 2
    },

    canBeSelected () {
      var selectable = this.seat.available && !this.isTakenByOtherPassengersOfTheSameBooking
      if (selectable) {
        if (['child', 'teen'].includes(this.currentPassenger.type)) {
          selectable = this.seat.childAllowed
        } else if (this.currentPassenger.infant) {
          selectable = this.seat.infantAllowed
        }
      }
      return selectable
    },

    isTakenByOtherPassengersOfTheSameBooking () {
      return this.selectedSeatsOnThisFlight.includes(this.seat.designator)
    },

    seatSelectedDataAttribute () {
      return this.isTakenByCurrentPassenger || this.isTakenByOtherPassengersOfTheSameBooking ? 'true' : 'false'
    },

    isTakenByCurrentPassenger () {
      return this.currentPassenger.seat && this.seat.designator === this.currentPassenger.seat.designator
    },

    hasHoverSeatInfo () {
      return this.canBeSelected || (this.isTakenByOtherPassengersOfTheSameBooking)
    },

    styles () {
      if (this.isTakenByCurrentPassenger) {
        return 'selected-for-this-passenger'
      }

      if (this.isTakenByOtherPassengersOfTheSameBooking) {
        return 'selected-for-other-passengers'
      }

      if (!this.seat.available) {
        return 'occupied'
      }

      let styles = 'group-' + this.seat.group
      if (this.seatMapGroup && this.seatMapGroup.hasOwnProperty('color')) {
        styles = 'seat-available'
      }

      if (this.currentPassenger.type === 'adult' && this.currentPassenger.infant && this.seat.infantAllowed) {
        styles += ' seat-infant'
      }

      if (this.hasExtraLeg) {
        styles += ' extraleg'
      }

      return styles
    }
  }
}
</script>
<style>
  .seat-price{
    font-size: 9px !important;
    font-weight: 700;
  }
  .seat-price-sm{
    font-size: 6px !important;
    font-weight: 700;
  }

    #ss-container .seat {
        /*height: 32px;*/
        width: 36px;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -ms-align-items: center;
        align-items: center;
        justify-content: center;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-size: 22px;
        cursor: pointer;
        position: relative;
        font-family: var(--fontFamily);
        margin: 0 4px;
    }
    #ss-container .seat:after {
        content: '';
        display: block;
        padding-top: 100%;
    }
    #ss-container .seat .seat-border {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 4px;
        background-color: rgba(0,0,0,.15);
        content: '';
    }
    #ss-container .seat--empty {
        color: var(--fontColor3);
        font-family: var(--fontFamily);
        font-size: 14px;
    }
    #ss-container .seat--column {
        height: 20px;
        font-family: var(--fontFamily);
    }
    #ss-container .seat:hover .seat--info {
        opacity: 1;
        display: flex;
    }
    #ss-container .seat--info-passenger {
      font-size: 16px;
    }

    #ss-container .seat--info.active {
      height: 45px;
    }
    #ss-container .seat--info.active strong {
      font-size: 19px;
    }

    #ss-container .seat--info {
        position: absolute;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        width: auto;
        padding: 3px 20px;
        white-space: nowrap;
        height: auto;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -ms-align-items: center;
        align-items: center;
        justify-content: center;
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;
        background-color: #FFFFFF;
        border-radius: 4px;
        z-index: 5;
        box-shadow: 0px 0px 10px rgba(0,0,0,.1);
        opacity: 0;
        display: none;
    }
    #ss-container .seat--info:before {
        position: absolute;
        content: '';
        left: 50%;
        bottom: -4px;
        transform: translateX(-50%) rotate(45deg);
        width: 10px;
        height: 10px;
        background-color: #FFFFFF;
    }
    #ss-container .seat--info strong {
        color: var(--fontColor2);
        font-size: 22px;
        margin: 0px 0px 3px;
    }
    #ss-container .seat--info span {
        color: var(--fontColor3);
        font-size: 16px;
    }
    #ss-container .seat--empty:after,
    #ss-container .seat--column:after {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        content: '';
        background-color: rgba(0,0,0,0);
    }
    #ss-container .selected-for-this-passenger {
        background: var(--seatSelectedColor);
        color: white;
    }
    #ss-container .selected-for-this-passenger:before {
        font-family: "bf_font_filled" !important;
        font-weight: 900;
        position: absolute;
        content: '\46';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        color: #FFFFFF;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -ms-align-items: center;
        align-items: center;
        justify-content: center;
    }
    #ss-container .selected-for-other-passengers {
        background: var(--seatSelectedColorOwned);
        color: white;
    }
    #ss-container .selected-for-other-passengers:before {
        font-family: "bf_font_filled" !important;
        font-weight: 900;
        position: absolute;
        content: '\46';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        color: #FFFFFF;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -ms-align-items: center;
        align-items: center;
        justify-content: center;
    }
    #ss-container .occupied {
        background: var(--seatOccupiedColor);
        color: white;
    }
    #ss-container .occupied:before {
        font-family: "bf_font_filled" !important ;
        font-weight: 900;
        position: absolute;
        content: '\65';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        color: #FFFFFF;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -ms-align-items: center;
        align-items: center;
        justify-content: center;
    }
    #ss-container .group-0 {
        background: var(--seatAvailable0Color);
    }
    #ss-container .group-1 {
        background: var(--seatAvailable1Color);
    }
    #ss-container .group-2 {
        background: var(--seatAvailable2Color);
    }
    #ss-container .seat-available {
      background: var(--seatAvailableColor) !important;
    }
    #ss-container .extraleg:before {
        position: absolute;
        content: '';
        /* background: url('../../static/img/exit.svg') no-repeat; */
        background-size: 100% 100%;
        width: 75%;
        height: 75%;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        -ms-align-items: center;
        align-items: center;
        justify-content: center;
    }

    #ss-container .seat-infant:before {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      position: absolute;
      content: "\F77C";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      color: #FFFFFF;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      -ms-align-items: center;
      align-items: center;
      justify-content: center;
    }

    #ss-container .seat--info-infant, #ss-container .seat--info-child {
      width: 300px;
      white-space: normal;
      height: auto;
      padding: 10px 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Seat.vue